<div class="mx-auto mt-10">
  <form
    [formGroup]="uploadForm"
    (ngSubmit)="onSubmit()"
    class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-8"
  >
    <h2 class="text-xl font-bold mb-8">Add Content to Project</h2>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

      <!-- ==================== FILE TYPE RADIO ==================== -->
      <div class="md:col-span-2 flex flex-col">
        <p class="text-sm font-medium pb-2">File Type</p>
        <div class="flex gap-6">
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              formControlName="fileType"
              value="document"
              (change)="onFileTypeChange('document')"
              checked
            />
            <span>Document</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              formControlName="fileType"
              value="video"
              (change)="onFileTypeChange('video')"
            />
            <span>Video</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              formControlName="fileType"
              value="faq"
              (change)="onFileTypeChange('faq')"
            />
            <span>FAQ</span>
          </label>
        </div>
      </div>
      
      <!-- ==================== PROJECT DROPDOWN ==================== -->
      <div class="flex flex-col">
        <label class="text-sm font-medium pb-2">Project Name <span class="text-red-500">*</span></label>
        <select
          class="form-select rounded-lg border border-gray-300 focus:border-gray-400 focus:ring-0 h-12 px-4 cursor-pointer"
          [ngClass]="{'border-red-500': uploadForm.get('product')?.touched && uploadForm.get('product')?.invalid}"
          formControlName="product"
          (change)="onProductChange($event)"
        >
          <option value="" disabled>Select a project</option>
          <option *ngFor="let product of products" [value]="product._id">
            {{ product.name }}
          </option>
        </select>
        <small
          class="text-red-500 mt-1"
          *ngIf="uploadForm.get('product')?.touched && uploadForm.get('product')?.invalid"
        >
          Project name is required
        </small>
      </div>

      <!-- ==================== MODULE DROPDOWN ==================== -->
      <div class="flex flex-col">
        <label class="text-sm font-medium pb-2">Module <span class="text-red-500">*</span></label>
        <select
          class="form-select rounded-lg border border-gray-300 focus:border-gray-400 focus:ring-0 h-12 px-4 cursor-pointer"
          [ngClass]="{'border-red-500': uploadForm.get('module')?.touched && uploadForm.get('module')?.invalid}"
          formControlName="module"
        >
          <option value="" disabled>Select a module</option>
          <option *ngFor="let module of modules" [value]="module._id">
            {{ module.moduleName }}
          </option>
        </select>
        <small
          class="text-red-500 mt-1"
          *ngIf="uploadForm.get('module')?.touched && uploadForm.get('module')?.invalid"
        >
          Module is required
        </small>
      </div>

      <!-- ==================== TITLE ==================== -->
      <div *ngIf="fileType !== 'faq'" class="md:col-span-2 flex flex-col">
        <label class="text-sm font-medium pb-2">
          Title <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          formControlName="title"
          class="form-input rounded-lg border border-gray-300 focus:border-gray-400 focus:ring-0 h-12 px-4"
          [ngClass]="{
            'border-red-500': uploadForm.get('title')?.touched && uploadForm.get('title')?.invalid
          }"
          placeholder="Enter a title for the asset"
        />
        <small
          class="text-red-500 mt-1"
          *ngIf="uploadForm.get('title')?.touched && uploadForm.get('title')?.invalid"
        >
          Title is required
        </small>
      </div>

      <!-- ==================== DESCRIPTION ==================== -->
      <div *ngIf="fileType !== 'faq'" class="md:col-span-2 flex flex-col">
        <label class="text-sm font-medium pb-2">Description <span class="text-red-500">*</span></label>
        <textarea
          formControlName="description"
          class="form-textarea rounded-lg border border-gray-300 focus:border-gray-400 focus:ring-0 h-28 p-4"
          [ngClass]="{'border-red-500': uploadForm.get('description')?.touched && uploadForm.get('description')?.invalid}"
          placeholder="Enter a detailed description..."
        ></textarea>
        <small
          class="text-red-500 mt-1"
          *ngIf="uploadForm.get('description')?.touched && uploadForm.get('description')?.invalid"
        >
          Description is required
        </small>
      </div>

      <!-- ==================== TAGS ==================== -->
      <div *ngIf="fileType !== 'faq'" class="md:col-span-2 flex flex-col">
        <label class="text-sm font-medium pb-2">Tags</label>
        <input
          formControlName="tags"
          class="form-input rounded-lg border border-gray-300 focus:border-gray-400 focus:ring-0 h-12 px-4"
          placeholder="Add tags, separated by commas"
        />
      </div>

      <!-- ==================== CREATED BY ==================== -->
      <div class="md:col-span-2 flex flex-col">
        <label class="text-sm font-medium pb-2">Created by <span class="text-red-500">*</span></label>
        <select
          class="form-select rounded-lg border border-gray-300 focus:border-gray-400 focus:ring-0 h-12 px-4 cursor-pointer"
          [ngClass]="{'border-red-500': uploadForm.get('createdBy')?.touched && uploadForm.get('createdBy')?.invalid}"
          formControlName="createdBy"
        >
          <option value="" disabled>Select a creator</option>
          <option *ngFor="let user of users" [value]="user._id">
            {{ user.first_name }} {{ user.last_name }}
          </option>
        </select>
        <small
          class="text-red-500 mt-1"
          *ngIf="uploadForm.get('createdBy')?.touched && uploadForm.get('createdBy')?.invalid"
        >
          Created by is required
        </small>
      </div>

      <!-- ==================== Question Answer ==================== -->
      <div *ngIf="fileType === 'faq'" class="md:col-span-2 flex flex-col">
        <label class="text-sm font-medium pb-2">
          Question <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          formControlName="question"
          class="form-input rounded-lg border border-gray-300 h-12 px-4"
          placeholder="Enter FAQ question"
        />
      </div>

      <div *ngIf="fileType === 'faq'" class="md:col-span-2 flex flex-col">
        <label class="text-sm font-medium pb-2">
          Answer <span class="text-red-500">*</span>
        </label>
        <textarea
          formControlName="answer"
          class="form-textarea rounded-lg border border-gray-300 h-28 p-4"
          placeholder="Enter FAQ answer"
        ></textarea>
      </div>

      

      <!-- ==================== DOCUMENT EDITOR ==================== -->
      <div *ngIf="fileType === 'document'" class="md:col-span-2">
        <h3 class="text-lg font-semibold mb-2">Document Editor</h3>
        <div
          #editorHolder
          class="border border-gray-300 rounded-lg p-4 min-h-[300px] bg-gray-50"
        ></div>
        <!-- <button
          type="button"
          (click)="saveDocument()"
          class="mt-4 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 cursor-pointer"
        >
          Save Document
        </button> -->
      </div>

      <!-- ==================== THUMBNAIL ==================== -->
      <div *ngIf="fileType === 'document' || fileType === 'video'" class="md:col-span-2">
        <label class="text-sm font-medium pb-2">
          Thumbnail Image
          <span *ngIf="fileType === 'video'" class="text-red-500">*</span>
        </label>

        <div
          class="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-8 text-center cursor-pointer hover:border-indigo-600 transition-colors hover:bg-indigo-50"
          [ngClass]="{
            'border-red-500': fileType === 'video' && !selectedThumbnail && (thumbnailTouched || formSubmitted )
          }"
          (drop)="onThumbnailDrop($event)"
          (dragover)="onDragOver($event)"
          (click)="thumbnailTouched = true; thumbnailInput.click()"
        >
          <span class="material-symbols-outlined text-4xl text-gray-400">image</span>
          <p class="mt-3 text-sm text-gray-600">Click or drag an image to set thumbnail</p>
          <input
            type="file"
            accept="image/*"
            #thumbnailInput
            class="hidden"
            (change)="onThumbnailSelected($event)"
          />
        </div>

        <small
          *ngIf="fileType === 'video' && !selectedThumbnail && (thumbnailTouched || formSubmitted )"
          class="text-red-500 mt-1"
        >
          Thumbnail image is required for video uploads
        </small>

        <div *ngIf="selectedThumbnail" class="space-y-3 mt-4">
          <div
            class="flex items-center justify-between text-sm p-3 bg-background-light dark:bg-gray-700/50 rounded-lg"
          >
            <div class="flex items-center gap-3">
              <span class="material-symbols-outlined text-indigo-600">image</span>
              <span class="font-medium">{{ selectedThumbnail.name }}</span>
            </div>
            <div class="flex items-center gap-4">
              <span class="text-gray-500 dark:text-gray-400">
                {{ formatBytes(selectedThumbnail.size) }}
              </span>
              <button
                type="button"
                class="text-gray-500 hover:text-red-500 transition-colors"
                (click)="removeThumbnail()"
              >
                <span class="material-symbols-outlined text-base">delete</span>
              </button>
            </div>
          </div>
          <div class="flex justify-center">
            <img
              [src]="thumbnailPreview"
              alt="Thumbnail preview"
              class="max-h-32 rounded-lg shadow-sm border border-gray-200"
            />
          </div>
        </div>
      </div>

      <!-- ==================== VIDEO UPLOAD ==================== -->
      <div *ngIf="fileType === 'video'" class="md:col-span-2 flex flex-col gap-6">
        <label class="text-sm font-medium pb-2">Upload Video (required) <span class="text-red-500">*</span></label>
        <div
          class="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-8 text-center cursor-pointer hover:border-primary transition-colors hover:bg-primary/5"
          [ngClass]="{'border-red-500': !selectedVideo && (videoTouched || formSubmitted )}"
          (drop)="onVideoDrop($event)"
          (dragover)="onDragOver($event)"
          (click)="videoTouched = true; videoInput.click()"
        >
          <span class="material-symbols-outlined text-5xl text-gray-400">cloud_upload</span>
          <p class="mt-4 text-lg font-semibold">Click or drag one video file to upload</p>
          <input type="file" accept="video/*" #videoInput class="hidden" (change)="onVideoSelected($event)">
        </div>

        <small *ngIf="!selectedVideo && (videoTouched || formSubmitted )" class="text-red-500 mt-1">
          Please upload a video file
        </small>

        <!-- Selected Video -->
        <div *ngIf="selectedVideo" class="space-y-3">
          <div class="flex items-center justify-between text-sm p-3 bg-background-light dark:bg-gray-700/50 rounded-lg">
            <div class="flex items-center gap-3">
              <span class="material-symbols-outlined text-primary">smart_display</span>
              <span class="font-medium">{{ selectedVideo.name }}</span>
            </div>
            <div class="flex items-center gap-4">
              <span class="text-gray-500 dark:text-gray-400">{{ formatBytes(selectedVideo.size) }}</span>
              <button
                type="button"
                class="text-gray-500 hover:text-red-500 transition-colors"
                (click)="removeVideo()"
              >
                <span class="material-symbols-outlined text-base">delete</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Supporting Files -->
        <label class="text-sm font-medium pb-2">Attach Supporting Files (optional)</label>
        <div
          class="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-8 text-center cursor-pointer hover:border-green-600 transition-colors hover:bg-green-50"
          (drop)="onDocDrop($event)"
          (dragover)="onDragOver($event)"
          (click)="attachedDocInput.click()"
        >
          <span class="material-symbols-outlined text-4xl text-gray-400">description</span>
          <p class="mt-3 text-sm text-gray-600">Click or drag files to attach</p>
          <input type="file" multiple #attachedDocInput class="hidden" (change)="onAttachedDocumentSelected($event)">
        </div>

        <!-- Selected Supporting Files -->
        <div *ngIf="selectedDocs.length" class="space-y-3">
          <div
            *ngFor="let doc of selectedDocs; let i = index"
            class="flex items-center justify-between text-sm p-3 bg-background-light dark:bg-gray-700/50 rounded-lg"
          >
            <div class="flex items-center gap-3">
              <span class="material-symbols-outlined text-accent">insert_drive_file</span>
              <span class="font-medium">{{ doc.name }}</span>
            </div>
            <div class="flex items-center gap-4">
              <span class="text-gray-500 dark:text-gray-400">{{ formatBytes(doc.size) }}</span>
              <button
                type="button"
                class="text-gray-500 hover:text-red-500 transition-colors"
                (click)="removeDoc(i)"
              >
                <span class="material-symbols-outlined text-base">delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== SUBMIT BUTTON ==================== -->
    <div class="md:col-span-2 flex justify-end mt-8">
      <button
        type="submit"
        class="h-12 px-8 bg-primary text-white font-semibold rounded-lg hover:bg-primary/90 transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="uploadForm.invalid || (fileType === 'video' && (!selectedThumbnail || !selectedVideo)) || isUploading"
      >
        <span *ngIf="!isUploading">Upload Asset</span>
        <span *ngIf="isUploading">Uploading...</span>
      </button>
    </div>
  </form>

  <!-- ==================== SUBMIT BUTTON ==================== -->
  <div
    class="fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-md bg-green-600 px-4 py-3 text-white shadow-lg transition-all duration-300"
    [ngClass]="{
      'translate-y-0 opacity-100': showToast,
      'translate-y-20 opacity-0': !showToast
    }"
  >
    <span class="material-symbols-outlined">check_circle</span>
    <p class="text-sm font-semibold">{{ toastMessage }}</p>
  </div>
</div>
